import { Dispatch, SetStateAction } from "react";

import Badge from "components/atoms/Badge/Badge";
import Button from "components/atoms/Button/Button";
import { InvoiceStatusColors } from "constants/";

interface NavigationProps {
  invoices: any[];
  currentInvoice: any;
  setCurrentInvoice: SetStateAction<Dispatch<any>>;
}

export default function Navigation({ invoices, currentInvoice, setCurrentInvoice }: NavigationProps) {
  return (
    <div>
      {invoices.map((invoice) => (
        <div className="d-flex align-items-center" style={{ marginBottom: 8 }} key={invoice.invoice_id}>
          <Button
            className="rounded-pill font-b2"
            onClick={() => setCurrentInvoice(invoice)}
            style={{
              padding: "6px 16px",
              border: "1px solid #252525",
              color: currentInvoice.invoice_id === invoice.invoice_id ? "white" : "#252525",
              backgroundColor: currentInvoice.invoice_id === invoice.invoice_id ? "#252525" : "white",
            }}
          >
            {invoice.invoice_id}
          </Button>
          <div className="d-flex align-items-center ml-2 font-b4">
            <Badge label={invoice?.invoice_status} type={InvoiceStatusColors[invoice?.invoice_status] || "secondary"} />
          </div>
        </div>
      ))}
    </div>
  );
}
